import { Modal } from 'antd';
import { trackPromise } from 'react-promise-tracker';
import { useOperationHook } from '../../../../../../hooks/useOperationHook';
import { useWaybillResolver } from '../../../../../../hooks/useWaybillResolver';
import { IQuotationPriceDetail, QUOTATION_KEY } from '../../../../../../model/EnquiryModal';
import { IManifestDetail, IManifestRequest, ManifestQuotationExtraCharges } from '../../../../../../model/OperationModel';
import { useOperationStore } from '../../../../../../stores/OperationStore';
import { useManifestContextHook } from '../Context/useManifestContextHook';
import { ValidateModal, isQuotation } from './RevalidateHook';

export const findValue = <T,>({ quotationPriceDetailList, key, filterKey }: { quotationPriceDetailList: T[], key: string, filterKey: string }): number | string => {
    return quotationPriceDetailList?.length ? (quotationPriceDetailList?.find(item => item?.['name'] === key)?.[filterKey]) : undefined;
};

const TOTAL_AMOUNT = 'selling',
    REMARKS = 'remarks',
    MANIFEST_QUOTATION_EXTRA_CHARGE = 'manifestQuotationExtraCharges';

//** This function bind the values from manifestation international charges and create an object */
export const quotationPriceDetailListRequest = ({ quotationPriceDetailList }: { quotationPriceDetailList: IQuotationPriceDetail[] }) => ({
    internationalFreightCharge: findValue({ quotationPriceDetailList, key: QUOTATION_KEY.INTERNATIONAL_FREIGHT_CHARGE, filterKey: TOTAL_AMOUNT }),
    originClearenceCharge: findValue({ quotationPriceDetailList, key: QUOTATION_KEY.ORIGIN_CLEARANCE_CHARGE, filterKey: TOTAL_AMOUNT }),
    originHandling: findValue({ quotationPriceDetailList, key: QUOTATION_KEY.ORIGIN_HANDLING, filterKey: TOTAL_AMOUNT }),
    originBayan: findValue({ quotationPriceDetailList, key: QUOTATION_KEY.ORIGIN_BAYAN, filterKey: TOTAL_AMOUNT }),
    destinationClearenceCharge: findValue({ quotationPriceDetailList, key: QUOTATION_KEY.DESTINATION_CLEARANCE_CHARGE, filterKey: TOTAL_AMOUNT }),
    destinationBayan: findValue({ quotationPriceDetailList, key: QUOTATION_KEY.DESTINATION_BAYAN, filterKey: TOTAL_AMOUNT }),
    transitCustomsDeclarationCharge: findValue({ quotationPriceDetailList, key: QUOTATION_KEY.TRANSIT_CUSTOMS_DECLARATION_CHARGE, filterKey: TOTAL_AMOUNT }),
    inspectionCharges: findValue({ quotationPriceDetailList, key: QUOTATION_KEY.INSPECTION_CHARGE, filterKey: TOTAL_AMOUNT }),
    loadingOffloadingCharges: findValue({ quotationPriceDetailList, key: QUOTATION_KEY.LOADING_OFFLOADING_CHARGES, filterKey: TOTAL_AMOUNT }),
    gatePassCharges: findValue({ quotationPriceDetailList, key: QUOTATION_KEY.GATE_PASS_CHARGES, filterKey: TOTAL_AMOUNT }),
    sealCharge: findValue({ quotationPriceDetailList, key: QUOTATION_KEY.SEAL_CHARGE, filterKey: TOTAL_AMOUNT }),
    penalty: findValue({ quotationPriceDetailList, key: QUOTATION_KEY.PENALTY, filterKey: TOTAL_AMOUNT }),
    detentionCharge: findValue({ quotationPriceDetailList, key: QUOTATION_KEY.DETENTION_CHARGE, filterKey: TOTAL_AMOUNT }),
    destinationHandling: findValue({ quotationPriceDetailList, key: QUOTATION_KEY.DESTINATION_HANDLING, filterKey: TOTAL_AMOUNT }),
    labTest: findValue({ quotationPriceDetailList, key: QUOTATION_KEY.LAB_TEST, filterKey: TOTAL_AMOUNT }),
    documentationCharges: findValue({ quotationPriceDetailList, key: QUOTATION_KEY.DOCUMENTATION_CHARGES, filterKey: TOTAL_AMOUNT }),
    localPickup: findValue({ quotationPriceDetailList, key: QUOTATION_KEY.LOCAL_PICKUP, filterKey: TOTAL_AMOUNT }),
    localDelivery: findValue({ quotationPriceDetailList, key: QUOTATION_KEY.LOCAL_DELIVERY, filterKey: TOTAL_AMOUNT }),
    pickupStorage: findValue({ quotationPriceDetailList, key: QUOTATION_KEY.PICK_UP_STORAGE, filterKey: TOTAL_AMOUNT }),
    deliveryStorage: findValue({ quotationPriceDetailList, key: QUOTATION_KEY.DELIVERY_STORAGE, filterKey: TOTAL_AMOUNT }),
    jafzaClearence: findValue({ quotationPriceDetailList, key: QUOTATION_KEY.JAFZA_CLEARANCE, filterKey: TOTAL_AMOUNT }),
    tollCharges: findValue({ quotationPriceDetailList, key: QUOTATION_KEY.TOLL_CHARGES, filterKey: TOTAL_AMOUNT }),
    borderAppointmentCharges: findValue({ quotationPriceDetailList, key: QUOTATION_KEY.BORDER_APPOINTMENT_CHARGES, filterKey: TOTAL_AMOUNT }),
    additionalDeliveryCharges: findValue({ quotationPriceDetailList, key: QUOTATION_KEY.ADDITIONAL_DELIVERY_CHARGES, filterKey: TOTAL_AMOUNT }),
    causewayBridgeCharges: findValue({ quotationPriceDetailList, key: QUOTATION_KEY.CAUSEWAY_BRIDGE_CHARGES, filterKey: TOTAL_AMOUNT }),
    miscellaneous: findValue({ quotationPriceDetailList, key: QUOTATION_KEY.MISCELLANEOUS, filterKey: TOTAL_AMOUNT }),
    customsDutyCharges: findValue({ quotationPriceDetailList, key: QUOTATION_KEY.CUSTOMS_DUTY, filterKey: TOTAL_AMOUNT }),
});

//** This function bind the values from manifestation international extra charges and create an object */

export const manifestQuotationExtraChargesRequest = ({ quotationPriceDetailList }: { quotationPriceDetailList: IQuotationPriceDetail[] }) => ({
    originHandlingCharges: findValue({ quotationPriceDetailList, key: QUOTATION_KEY.ORIGIN_HANDLING, filterKey: MANIFEST_QUOTATION_EXTRA_CHARGE }),
    destinationHandlingCharges: findValue({ quotationPriceDetailList, key: QUOTATION_KEY.DESTINATION_HANDLING, filterKey: MANIFEST_QUOTATION_EXTRA_CHARGE }),
    detentionCharge: findValue({ quotationPriceDetailList, key: QUOTATION_KEY.DETENTION_CHARGE, filterKey: MANIFEST_QUOTATION_EXTRA_CHARGE }),
    labTest: findValue({ quotationPriceDetailList, key: QUOTATION_KEY.LAB_TEST, filterKey: MANIFEST_QUOTATION_EXTRA_CHARGE }),
    loadingOffloadingCharge: findValue({ quotationPriceDetailList, key: QUOTATION_KEY.LOADING_OFFLOADING_CHARGES, filterKey: MANIFEST_QUOTATION_EXTRA_CHARGE }),
    penalty: findValue({ quotationPriceDetailList, key: QUOTATION_KEY.PENALTY, filterKey: MANIFEST_QUOTATION_EXTRA_CHARGE }),
    sealCharge: findValue({ quotationPriceDetailList, key: QUOTATION_KEY.SEAL_CHARGE, filterKey: MANIFEST_QUOTATION_EXTRA_CHARGE }),
    documentationCharges: findValue({ quotationPriceDetailList, key: QUOTATION_KEY.DOCUMENTATION_CHARGES, filterKey: MANIFEST_QUOTATION_EXTRA_CHARGE }),
    remarks: findValue({ quotationPriceDetailList, key: QUOTATION_KEY.ORIGIN_HANDLING, filterKey: REMARKS }),
    localPickup: findValue({ quotationPriceDetailList, key: QUOTATION_KEY.LOCAL_PICKUP, filterKey: MANIFEST_QUOTATION_EXTRA_CHARGE }),
    localDelivery: findValue({ quotationPriceDetailList, key: QUOTATION_KEY.LOCAL_DELIVERY, filterKey: MANIFEST_QUOTATION_EXTRA_CHARGE }),
    pickupStorage: findValue({ quotationPriceDetailList, key: QUOTATION_KEY.PICK_UP_STORAGE, filterKey: MANIFEST_QUOTATION_EXTRA_CHARGE }),
    deliveryStorage: findValue({ quotationPriceDetailList, key: QUOTATION_KEY.DELIVERY_STORAGE, filterKey: MANIFEST_QUOTATION_EXTRA_CHARGE }),
    additionalDeliveryCharges: findValue({ quotationPriceDetailList, key: QUOTATION_KEY.ADDITIONAL_DELIVERY_CHARGES, filterKey: MANIFEST_QUOTATION_EXTRA_CHARGE }),
    causewayBridgeCharges: findValue({ quotationPriceDetailList, key: QUOTATION_KEY.CAUSEWAY_BRIDGE_CHARGES, filterKey: MANIFEST_QUOTATION_EXTRA_CHARGE }),
    jafzaClearence: findValue({ quotationPriceDetailList, key: QUOTATION_KEY.JAFZA_CLEARANCE, filterKey: MANIFEST_QUOTATION_EXTRA_CHARGE }),
    tollCharges: findValue({ quotationPriceDetailList, key: QUOTATION_KEY.TOLL_CHARGES, filterKey: MANIFEST_QUOTATION_EXTRA_CHARGE }),
    borderAppointmentCharges: findValue({ quotationPriceDetailList, key: QUOTATION_KEY.BORDER_APPOINTMENT_CHARGES, filterKey: MANIFEST_QUOTATION_EXTRA_CHARGE }),
}) as ManifestQuotationExtraCharges

const SaveHook = () => {
    const SaveManifestAction = useOperationStore((state) => state?.SaveManifestAction);
    const { id: manifestId, manifetDetail } = useOperationStore((state) => state?.manifestationList) || {};
    const selectedQuotation = useOperationStore((state) => state?.selectedQuotation);
    const manifestationList = useOperationStore((state) => state?.manifestationList);
    const { manifestQuote: manifestQuoteContext, billTypeId, isInternational, consigneeUpdated } = useManifestContextHook();
    const { manifestQuote } = selectedQuotation ?? {};
    const { bookingDate } = useOperationHook();
    const waybillNo = useWaybillResolver();
    const { enquiryId, enquiryQuotationId } = manifestQuote ?? manifestQuoteContext ?? {};
    const buildAndSaveRequest = (values: IManifestRequest) => {
        const quotationPriceDetailList = values?.quotationPriceDetailList ?? [];
        const IRSExtraCharges = manifestQuotationExtraChargesRequest({ quotationPriceDetailList })
        if (isQuotation({ isInternational, billTypeId, bookingDate, enquiryId })) {
            ValidateModal();
            return;
        }
        const request = {
            ...manifestationList,
            destinationOdaCityId: values?.destinationOdaCityId,
            destinationIsoda: Boolean(values?.destinationOdaCityId),
            originOdaCityId: values?.originOdaCityId,
            originIsoda: Boolean(values?.originOdaCityId),
            multiDestinationCharges: +(values?.multiDestinationCharges ?? 0),
            podCharges: +(values?.podCharges ?? 0),
            podServiceDetails: +(values?.podServiceDetails ?? 0),
            forkliftAmount: +(values?.forkliftAmount ?? 0),
            labourCharges: +(values?.labourCharges ?? 0),
            id: manifestId,
            wayBillNo: waybillNo,
            manifestQuote: {
                manifestId,
                enquiryQuotationId: enquiryId
            },
            manifetDetail: {
                id: manifetDetail?.id,
                waybillNo: waybillNo,
                stdShipmentAmount: +(values?.stdShipmentAmount ?? 0),
                originOdaCharge: +(values?.originOdaCharge ?? 0),
                destOdaCharge: +(values?.destOdaCharge ?? 0),
                otherCharges: +(values?.otherCharges ?? 0),
                otherCharges3: +(values?.otherCharges3 ?? 0),
                otherCharges4: +(values?.otherCharges4 ?? 0),
                otherCharges5: +(values?.otherCharges5 ?? 0),
                podCharges: +(values?.podCharges ?? 0),
                insuranceCharges: +(values?.insuranceCharges ?? 0),
                insurancePercentage: +(values?.insurancePercentage ?? 0),
                insuranceValue: +(values?.insuranceValue ?? 0),
                additionalWeight: +(values?.additionalWeight ?? 0),
                netValue: +(values?.netValue ?? 0),
                // surCharge: +values?.totalCharge ?? 0,
                manualFreightCharges: +(values?.manualFreightCharges ?? 0),
                // otherCharge3: +(values?.otherCharge3 ?? 0),
                // otherCharge2: +(values?.otherCharge2 ?? 0),
                // otherCharge1: +(values?.otherCharge1 ?? 0),
                demurrageCharge: +(values?.demurrageCharge ?? 0),
                remarks: values?.remarks,
                internationalNetAmount: +(values?.internationalNetAmount ?? 0),
                internationalVatPercentage: +(values?.internationalVatPercentage ?? 0),
                internationalVatAmount: +(values?.internationalVatAmount ?? 0),
                internationalGrossAmount: +(values?.internationalGrossAmount ?? 0),
                domesticGrossAmount: +(values?.domesticGrossAmount ?? 0),
                totalNetAmount: +(values?.totalNetAmount ?? 0),
                totalGrossAmount: +(values?.totalGrossAmount ?? 0),
                originOdaChargeExempt: values?.originOdaChargeExempt,
                destinationOdaChargeExempt: values?.destinationOdaChargeExempt,
                oversizeShipmentCharge: values?.oversizeShipmentCharge,
                waitingCharge: values?.waitingCharge,
                consigneeCharges: values?.consigneeCharges,
                ...quotationPriceDetailListRequest({ quotationPriceDetailList })
            } as IManifestDetail,
            manifestQuotationExtraCharges: Object.entries(IRSExtraCharges)?.length ? {
                ...IRSExtraCharges,
                enquiryQuotation: enquiryQuotationId,
                enquiryQuotationId: enquiryId,
                // manifestDetailId,
                manifestId,
                // manifestQuoteId,
            } as ManifestQuotationExtraCharges : undefined
        };
        trackPromise(SaveManifestAction({ waybillNo, request }), 'button-click-area')
    };

    const onSubmit = (values: IManifestRequest) => {
        if (isQuotation({ isInternational, billTypeId, bookingDate, enquiryId })) {
            ValidateModal();
            return;
        }
        if (consigneeUpdated && +(values?.consigneeCharges ?? 0) === 0) {
            Modal.confirm({
                title: 'Consignee Address Change',
                content: 'Consignee address updated. Do you want to proceed with 0 as the charge?',
                okText: 'Yes',
                cancelText: 'Cancel',
                onOk: () => buildAndSaveRequest(values)
            });
            return;
        }
        buildAndSaveRequest(values);
    };
    return { onSubmit }
}

export default SaveHook